import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import Cris from "@/pages/Cris";

export const Route = createFileRoute("/cris")({
  head: () => buildHead({
    title: "Redirecionando | OP2P",
    description: "Redirecionamento para o contato direto da OP2P.",
    path: "/cris",
    noindex: true,
  }),
  component: Cris,
});
